import i18n from '../../lang/index'
const sslRouter = [{
  path: '/ssl',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'sslindex'
  },
  children: [{
    name: 'sslindex',
    path: 'index/instance',
    meta: {
      title: i18n.t('ssl.title'),
    },
    component: () => import('@/pages/ssl/SslIndex')
  }, {
    name: 'ssldetail',
    path: 'instance/detail',
    meta: {
        title: i18n.t('ssl.view.title'),
    },
    component: () => import('@/pages/ssl/SslInformation')
  }]
}]
export default sslRouter



// WEBPACK FOOTER //
// ./src/router/modules/ssl.js